var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table-column',{attrs:{"prop":_vm.prop,"label":_vm.label},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',{style:(_vm.childStyles(scope.row))},[_vm._v(" "+_vm._s(scope.row[_vm.prop])+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }